import { render, staticRenderFns } from "./reports-home.vue?vue&type=template&id=f0351d7c"
import script from "./reports-home.vue?vue&type=script&lang=js"
export * from "./reports-home.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports